import patternize from '@formatters/patternize';

import {
  CODE_FORMAT,
  CODE_REGEX,
} from './phone';

export default function phoneCode(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const formatted = patternize(value, {
    format: CODE_FORMAT,
  });

  if (CODE_REGEX.test(formatted)) {
    return false;
  }

  return true;
}

phoneCode.message = function message(value, options = {}) {
  return options.message || 'precisa ser um DDD válido';
};
